module.exports.publisherApprovalCallback = function(button, approved) {
    let badgeHelper = require("badge-helper");
    let showFlash = require("flash-message");
    showFlash = showFlash.default;

    var $row = $(button).parents("tr");

    var total = 0;
    total += parseInt($row.find(".pending-count").html());
    total += parseInt($row.find(".approved-count").html());
    total += parseInt($row.find(".disapproved-count").html());

    $row.find(".pending-count").html(0);
    $row.find(".disapproved-count").html(0);
    $row.find(".approved-count").html(0);

    var selector = approved ? ".approved-count" : ".disapproved-count";

    $row.find(selector).html(total);

    var totalPending = 0;
    $row.parents("table")
        .find("tr:gt(0)")
        .each(function() {
            totalPending += parseInt(
                $(this)
                    .find(".pending-count")
                    .html(),
            );
        });

    import("badge-helper").then(badgeHelper => badgeHelper.updateNavBadge("mainnav-affiliates", totalPending));

    var ap = approved ? "Approved" : "Disapproved";

    // Delete row if affiliate is disapproved
    if (!approved) {
        const $tbody = $row.parents("tbody");
        $row.fadeOut(function() {
            $(this).remove();
            if ($tbody.find("tr").size() === 0) {
                $tbody.append('<tr><td colspan="9">No affiliates found&hellip;</td></tr>');
            }
        });
    }

    showFlash("success", ap + " affiliate for " + total + " programs");
};

module.exports.payoutPaidCallback = function(button, approved) {
    $(button).trigger("payout.approval.updated");
};

module.exports.approveCommissionCallback = function(button, approved) {
    if ($(button).data("pending")) {
        import("badge-helper").then(badgeHelper => badgeHelper.decrement("mainnav-conversions", 1));
        $(button)
            .siblings(".approve-commission, .disapprove-commission")
            .removeData("pending");
    }
};
